import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router'

import { LemonatorNakyma } from '../../_jaettu-lemonator/model/lemonator-nakyma'
import { AsiakasComponentDataResolve } from '../_resolvers/asiakas.resolve'
import { KirjanpitajaService } from '../service/kirjanpitaja/kirjanpitaja.service'
import { KirjautunutKayttajaService } from '../service/kirjautunut-kayttaja.service'

import { Observable, combineLatest, of as observableOf } from 'rxjs'
import { map, tap } from 'rxjs/operators'

@Injectable()
export class NakymaGuard {
  constructor(
    private _router: Router,
    private _kirjautunutKayttajaService: KirjautunutKayttajaService,
    private _kirjanpitajaService: KirjanpitajaService,
    private _asiakasResolve: AsiakasComponentDataResolve,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const nakymaAvain = route.data.nakymaAvain as LemonatorNakyma
    if (!nakymaAvain) {
      return observableOf(true)
    }

    const asiakasObservable = route.paramMap.get('asiakasAvain') ? this._asiakasResolve.resolve(route) : observableOf(null)

    return combineLatest([this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable, this._kirjanpitajaService.kirjautuneenKayttajanKirjanpitajaObservable, asiakasObservable]).pipe(
      map(([tiedot, kirjanpitaja, asiakas]) => {
        if (!tiedot) {
          return false
        }
        if (asiakas && (asiakas.kasittelija === tiedot.uid || asiakas.kasittelijavara === tiedot.uid)) {
          return true
        }
        // Jos allowedViews ei ole määritelty, sallitaan kaikki (taaksepäin yhteensopivuus)
        if (!kirjanpitaja?.allowedViews || Object.keys(kirjanpitaja.allowedViews).length === 0) {
          return true
        }
        return !!kirjanpitaja.allowedViews[nakymaAvain]
      }),
      tap(sallittu => {
        if (!sallittu) {
          this._router.navigate(['/'])
        }
      }),
    )
  }
}
